import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconsModule } from '@anecdotes/design-system/svg-icons';
import { LoadersModule } from '@anecdotes/design-system/loaders';
import { TipComponent } from './components';
import { TipManagerService } from './services';
import { WindowHelperService } from '@anecdotes/utils';

@NgModule({
  declarations: [TipComponent],
  imports: [
    CommonModule,
    TranslateModule,
    SvgIconsModule,
    LoadersModule,
    RouterModule,
    NgbTooltipModule
  ],
  exports: [
    TipComponent,
  ],
  providers: [
    TipManagerService,
    WindowHelperService,
  ]
})
export class TipsModule { }
